// extracted by mini-css-extract-plugin
module.exports = {"logo":"style-module--logo--2rhPr","white":"style-module--white--28mXO"};